import LiSchedulingApply from "./src/index.vue";

LiSchedulingApply.install = function (Vue) {
  Vue.component(LiSchedulingApply.name, LiSchedulingApply);
};

export default LiSchedulingApply;
